import gql from 'graphql-tag';

export const login = gql`mutation getToken($user: String!, $pass: String!) {
    getToken(user: $user, pass: $pass) {
        token
        user {
            name
            email
            role {
                code
            }
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/login.js